import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseSendSMS } from "./UseSendSMS";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CustomPagination from "../../components/CustomPagination";
import { removeComma, toMoney } from "../../util/Utils";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import DeleteRow from "../../components/DeleteRow";
import { useSnackbar } from "notistack";
import LoadingButton from "@mui/lab/LoadingButton";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function SendGroupSMS(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { deleteBunch, GetBunchList, setBunch } = UseSendSMS();
  const [BunchRes, setBunchRes] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [SMSCount, setSMSCount] = useState();
  const [secondState, setSecondState] = useState(0);
  const [state, setState] = useState({
    count: 1000,
    id: undefined,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [pageState, setPageState] = useState({
    page: 1,
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [keepGoing, setkeepGoing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.expanded === "SMS2") {
      setProgress(true);
      GetBunchList(true, (callback) => {
        setBunchRes(callback);
      });
    } else {
      setState({
        count: 1000,
        id: undefined,
      });
      setMessageText("");
      setBunchRes([]);
    }
  }, [props.expanded]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("SMS2");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  const [timeLeft, setTimeLeft] = useState(null);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (timeLeft === 0) {
      setTimeLeft(secondState);
    }
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    //
    if (SMSCount > 0 && secondState > 0 && keepGoing) {
      setTimeLeft(secondState);
      const interval = setInterval(() => {
        setBunch(state, () => {
          GetBunchList(true, (callback) => {
            setBunchRes(callback);
          });
        });
      }, secondState * 1000);

      return () => clearInterval(interval);
    } else {
      setkeepGoing(false);
    }
  }, [secondState, keepGoing]);

  useEffect(() => {
    if (BunchRes && state.id) {
      let count = BunchRes.find((m) => m.id == state.id)?.count;
      if (count) {
        setSMSCount(count);
      } else {
        setSMSCount(0);
        setkeepGoing(false);
        setSecondState(0);
      }
    } else {
      setSMSCount(0);
      setkeepGoing(false);
      setSecondState(0);
    }
  }, [BunchRes, state]);

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 250,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "count",
      headerName: "تعداد",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span">
            {cellValues.row.count ? toMoney(cellValues.row.count) : 0}
          </Typography>
        );
      },
    },
  ];

  return (
    <Accordion
      id="SMS2"
      expanded={props.expanded === "SMS2"}
      onChange={handleChange("SMS2")}
      style={{
        paddingBottom: "15px",
        marginTop: "30px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            ارسال SMS گروهی
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          <DataGrid
            className="ltr-grid"
            sx={{
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "&  .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "&  .MuiDataGrid-cell:focus-within ": {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
              "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
              "& .MuiDataGrid-cell:hover": {
                //   opacity: "80%",
                color: "primary.main",
                cursor: "pointer",
              },
              "& .MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !important",
              },
            }}
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={BunchRes}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={BunchRes ? BunchRes.length : 1}
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                nofab: true,
                isLtr: true,
                rowCount: BunchRes ? BunchRes.length : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "id",
                    sort: "asc",
                  },
                ],
              },
            }}
            onRowClick={(row, cellValues) => {
              setMessageText(row.row.message);
              setState({ ...state, id: row.row.id });
            }}
          />
        </Box>
        <Box
          sx={{
            my: 3,
          }}
        >
          <TextField
            fullWidth
            value={
              messageText
                ? messageText
                    .replace(/(<([^>]+)>)/gi, "")
                    .replace(/(&nbsp;)/gi, " ")
                : ""
            }
            label="پیام"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            multiline
            maxRows={10}
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <TextField
            fullWidth
            value={state.count ? toMoney(state.count) : ""}
            label="تعداد"
            sx={{
              width: isSmall ? "100%" : "15%",
              input: { textAlign: "center" },
            }}
            size="small"
            variant="outlined"
            onKeyDown={(e) => {
              exceptThisSymbols.includes(e.key) && e.preventDefault();
            }}
            onChange={(event, value) => {
              if (event.target.value) {
                const sanitizedValue = event.target.value.replace(
                  /[^0-9.]/g,
                  ""
                );
                setState({
                  ...state,
                  count: removeComma(Number(sanitizedValue)),
                });
              } else {
                setState({
                  ...state,
                  count: undefined,
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: {
                min: 1,
              },
            }}
          />
          <TextField
            fullWidth
            value={secondState ? toMoney(secondState) : 0}
            label="ثانیه"
            sx={{
              width: isSmall ? "100%" : "8%",
              input: { textAlign: "center" },
            }}
            size="small"
            variant="outlined"
            onKeyDown={(e) => {
              exceptThisSymbols.includes(e.key) && e.preventDefault();
            }}
            disabled={keepGoing}
            onChange={(event, value) => {
              if (event.target.value == 0 || event.target.value == "0") {
                setSecondState(0);
              } else if (event.target.value) {
                const sanitizedValue = event.target.value.replace(
                  /[^0-9.]/g,
                  ""
                );
                setSecondState(Number(sanitizedValue));
              } else {
                setSecondState(0);
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: {
                min: 0,
              },
            }}
          />
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
            {keepGoing ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <LoadingButton
                    loading={keepGoing}
                    loadingPosition="start"
                    // startIcon={<SaveIcon />}
                    variant="outlined"
                    color="secondary"
                  >
                    ارسال
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setkeepGoing(false);
                      setLoading(false);
                    }}
                  >
                    انصراف
                  </Button>
                </Box>
                <Typography variant="caption">( {timeLeft} ثانیه )</Typography>
              </Box>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (!state.id || !state.count) {
                    enqueueSnackbar("لطفا پیام و تعداد را کامل وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setCheckState({ name: "ارسال SMS", show: true });
                }}
              >
                ارسال
              </Button>
            )}
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                if (!state.id) {
                  enqueueSnackbar("لطفا پیام را انتخاب کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                setDeleteState({
                  id: state.id,
                  show: true,
                });
              }}
            >
              حذف
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setState({
                  count: 1000,
                  id: undefined,
                });
                setMessageText("");
              }}
            >
              جدید
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          if (secondState !== 0) {
            setBunch(state, () => {
              GetBunchList(true, (callback) => {
                setBunchRes(callback);
              });
            });
            setkeepGoing(true);
            return;
          } else if (secondState == 0) {
            setkeepGoing(false);
            setProgress(true);
            setBunch(state, () => {
              setState({
                count: 1000,
                id: undefined,
              });
              setMessageText("");
              GetBunchList(true, (callback) => {
                setBunchRes(callback);
              });
            });
          }
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"SMS"}
        callback={() => {
          setProgress(true);
          deleteBunch(deleteState.id, () => {
            setProgress(true);
            setState({
              count: 1000,
              id: undefined,
            });
            setMessageText("");
            GetBunchList(true, (callback) => {
              setBunchRes(callback);
            });
          });
        }}
      ></DeleteRow>
    </Accordion>
  );
}
